import { CvCvSectionCvSectionTypeEnum, CvSectionProfile } from '@/../gen';
import { CvCvSectionWithSection } from '@/store/modules/cvPreview';

export function makeSectionsMap(
  cvSectionProfile: CvSectionProfile,
  cvCvSections: CvCvSectionWithSection[],
  templateName: string
) {
  let sectionsMain = [];
  const sectionsSide = [];
  let profileMain = null;
  let profileSide = null;

  if (['casual_modern', 'simple_black'].includes(templateName)) {
    profileMain = cvSectionProfile;

    // first link section
    const firstLinkSection = cvCvSections.find(
      s => s.cv_section_type === CvCvSectionCvSectionTypeEnum.CvSectionLink
    );
    if (firstLinkSection) sectionsSide.push(firstLinkSection);
    // others
    sectionsMain = cvCvSections.filter(s => !sectionsSide.includes(s));
  }
  // two column
  else if (['engineer', 'sns_worker', 'proff_card'].includes(templateName)) {
    profileSide = cvSectionProfile;

    // first text section
    const firstTextSection = cvCvSections.find(
      s => s.cv_section_type === CvCvSectionCvSectionTypeEnum.CvSectionText
    );
    if (firstTextSection) sectionsSide.push(firstTextSection);
    //  first link section
    const firstLinkSection = cvCvSections.find(
      s => s.cv_section_type === CvCvSectionCvSectionTypeEnum.CvSectionLink
    );
    if (firstLinkSection) sectionsSide.push(firstLinkSection);
    // others
    sectionsMain = cvCvSections.filter(s => !sectionsSide.includes(s));
  } else {
    profileMain = cvSectionProfile;
    sectionsMain = cvCvSections;
  }

  return {
    side: {
      profile: profileSide,
      sections: sectionsSide,
    },
    main: {
      profile: profileMain,
      sections: sectionsMain,
    },
  };
}
